export default __webpack_public_path__ + "static/media/25.32026b60.png";